export const setIsStartTimer = () => ({
    type: "SET_START_TIMER"
});

export const setIsStopTimer = () => ({
    type: "SET_STOP_TIMER"
});
